import React from 'react'
import { forwardRef } from '@grupoboticario/flora-react-system'
import { useComposedRefs } from '@radix-ui/react-compose-refs'
import { Input } from '@grupoboticario/flora-react-input'
import { useDropdown, DropdownProps } from './libs/useDropdown'
import { DropdownIcon } from './DropdownComponents'

export const DropdownNative = forwardRef<'input', DropdownProps>(
  (
    {
      multiple,
      children,
      disabled,
      value: valueProp,
      defaultValue,
      renderValue, // eslint-disable-line @typescript-eslint/no-unused-vars
      onOpenChange, // eslint-disable-line @typescript-eslint/no-unused-vars
      onChange,
      readOnly,
      native,
      variant,
      ...props
    },
    forwardRef,
  ) => {
    const { items, value, inputSelectRef, handleChange, filled } = useDropdown<HTMLSelectElement>({
      multiple,
      native,
      children,
      valueProp,
      defaultValue,
      onChange,
      readOnly,
      variant,
    })

    const composedRefs = useComposedRefs(forwardRef, inputSelectRef)

    return (
      <Input
        ref={composedRefs}
        {...props}
        as="select"
        css={{
          ...(props.css || {}),
          '$$input-padding-label-top': '15px',
          appearance: 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
          ...(multiple && {
            height: 'auto',
          }),
          ...(!filled &&
            !multiple && {
              color: 'transparent',
            }),
        }}
        rightIcon={<DropdownIcon />}
        filled={multiple || filled}
        disabled={disabled}
        value={value}
        variant={variant}
        multiple={multiple}
        onChange={handleChange}
        data-flora={multiple ? 'multiple-select' : 'select'}
      >
        {items}
      </Input>
    )
  },
)
